<template>
  <b-card
    no-body
    class=" border border-2 h-100"
  >
    <div class="flex justify-between items-start mb-2 px-1 pt-1">
      <div>
        <div class="font-bold text-[16px] text-black">
          Total Closing Order
        </div>
        <div class="text-[#A0A0A0] text-[12px]">
          Top partner successfully closing the order
        </div>
      </div>
      <MonthFilter
        :month.sync="month"
      />
    </div>

    <div class="px-1">
      <b-table
        show-empty
        :items="tableData"
        :fields="tableFields"
        thead-tr-class="bg-[#f3f4f6]"
        class="mb-0 text-[14px] border border-[#e5e7eb] rounded-lg overflow-hidden"
      >
        <template #empty>
          <div class="text-center py-4 text-[#828282]">
            Tidak Ada Data
          </div>
        </template>
        <template #cell(name)="data">
          <span class="text-black font-medium">{{ data.value }}</span>
        </template>
        <template #cell(action)="data">
          <span class="text-[#F97316] cursor-pointer hover:underline" @click="goToDetail(data.item.id)">Details</span>
        </template>
      </b-table>
    </div>
  </b-card>
</template>

<script>
import moment from 'moment'
import { START_DATE_OF_MONTH, END_DATE_OF_MONTH } from '@/libs/filterDate'
import { IDRWithoutLbl } from '@/libs/currency'
import MonthFilter from './MonthFilter.vue'
import { apiDataClosing } from '../services/api.komchat.service'
import { fieldsClosingOrder } from '../config'

export default {
  name: 'TotalClosingOrder',
  components: {
    MonthFilter,
  },
  data() {
    return {
      moment,
      month: moment(),
      tableFields: fieldsClosingOrder,
      tableData: [],
    }
  },
  watch: {
    month() {
      this.fetchData()
    },
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      const startDate = START_DATE_OF_MONTH(this.month)
      const endDate = END_DATE_OF_MONTH(this.month)

      try {
        const res = await apiDataClosing({ startDate, endDate })
        if (res && res.data && res.data.data) {
          this.tableData = res.data.data.map(item => ({
            id: item.user_id,
            name: item.partner_name,
            nominal: `Rp ${IDRWithoutLbl(item.nominal || 0)}`,
            jumlah: item.closing || 0,
          }))
        } else {
          this.tableData = []
        }
      } catch (err) {
        console.error('Failed to fetch total closing order', err)
      }
    },
    goToDetail(id) {
      if (id) {
        this.$router.push({ name: 'partner-komchat-detail', params: { id } })
      }
    },
  },
}
</script>

<style scoped>
/* To make the table wrapper rounded we need this if b-table doesn't clip cleanly */
::v-deep .table {
  margin-bottom: 0;
}
::v-deep .table th {
  border-top: none;
}
</style>
